import React from 'react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import '../styles/index.scss';

interface DriveRootProps {
  children: React.ReactNode;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export function DriveRoot({children}: DriveRootProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
